module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_7042.0e5426bc.png";